import { apiGet } from './client';
import type { SignalCareRole } from './types';

// ============================================================================
// Phase 4 M5 — Evaluations page endpoints.
// ============================================================================

export interface PromptEvalRow {
  matrixResultId: string;
  runId: string;
  promptId: string;
  promptName: string;
  role: string;
  questionId: string;
  questionText: string;
  chatModelId: string;
  providerName: string;
  modelName: string;
  overallScore: number;
  groundednessScore: number;
  relevanceScore: number;
  citationScore: number;
  safetyScore: number;
  estimatedCostUsd: number;
  latencyMs: number;
  isError: boolean;
  createdAt: string;
}

export interface PromptWinnerByRoleItem {
  promptId: string;
  promptName: string;
  status: 'ok' | 'insufficient_data' | 'no_data';
  winningChatModelId: string | null;
  providerName: string | null;
  modelName: string | null;
  avgOverallScore: number | null;
  sampleCount: number;
}

export interface PromptEvalFilters {
  role?: SignalCareRole;
  chatModelIds?: string[];
  from?: string;             // ISO datetime
  to?: string;
  scoreMin?: number;
  scoreMax?: number;
  q?: string;
  limit?: number;
}

function buildQuery(f: PromptEvalFilters): string {
  const parts: string[] = [];
  if (f.role) parts.push(`role=${encodeURIComponent(f.role)}`);
  if (f.chatModelIds?.length) parts.push(`chatModelIds=${encodeURIComponent(f.chatModelIds.join(','))}`);
  if (f.from) parts.push(`from=${encodeURIComponent(f.from)}`);
  if (f.to) parts.push(`to=${encodeURIComponent(f.to)}`);
  if (f.scoreMin !== undefined) parts.push(`scoreMin=${f.scoreMin}`);
  if (f.scoreMax !== undefined) parts.push(`scoreMax=${f.scoreMax}`);
  if (f.q) parts.push(`q=${encodeURIComponent(f.q)}`);
  if (f.limit) parts.push(`limit=${f.limit}`);
  return parts.length ? `?${parts.join('&')}` : '';
}

export const listPromptEvals = (f: PromptEvalFilters = {}) =>
  apiGet<PromptEvalRow[]>(`/api/evaluations/prompt${buildQuery(f)}`);

export const listWinnersByRole = (role: SignalCareRole, windowDays = 30) =>
  apiGet<PromptWinnerByRoleItem[]>(
    `/api/evaluations/winner-by-role?role=${encodeURIComponent(role)}&windowDays=${windowDays}`,
  );
